import type { PortableTextMarkComponentProps } from '@portabletext/react';

export const externalLinkGroq = /* groq */ `
{
    _type,
    href,
    blank,
    button
}
`;

export function ExternalLink({
    value,
    children,
}: PortableTextMarkComponentProps<{
    _type: 'link';
    href?: string;
    blank?: boolean;
    button?: string;
}>) {
    return (
        <a
            href={value?.href}
            target={value?.blank ? '_blank' : undefined}
            rel={value?.blank ? 'noreferrer' : undefined}
            className={value?.button === 'secondary-button' ? 'btn-secondary' : value?.button === 'primary-button' ? 'btn-primary' : undefined}
        >
            {children}
        </a>
    );
}
